import styled from 'styled-components';

export const FloatMenu = styled.div`
    position: absolute;
    top: 30px;
    right: 20px;
    display: inline-block;
    z-index: 1;
`;
